module.exports = __webpack_public_path__ + "img/dice-logo2.753779d3.svg";